export default function (state) {
    switch (state.type) {
        case 'edit':
            return 'Бюджет № ' +  state.form.Number;
        case 'add':
        default:
            return 'Добавление бюджета';
    }
}
